module.exports = __webpack_public_path__ + "static/media/self.448a0a91.png";